module.exports = __webpack_public_path__ + "media/homepage_video.asset.16ae77ed.mp4";